import React from "react";
import LineChart from "../components/dashboard/reportChart";
import { Typography } from "antd";
import CommonAdminTable from "../components/commonTable";
const { Title } = Typography;

const Dashboard = () => {
  const columns = [
    {
      key: 0,
      title: "Name",
      dataIndex: "name",
    },
    {
      key: 1,
      title: "Email",
      dataIndex: "email",
    },
    {
      key: 2,
      title: "Seller Code",
      dataIndex: "seller_code",
    },
    {
      key: 3,
      title: "Total Sales",
      dataIndex: "total_sales",
    },
  ];
  const dataSource = [
    {
      key: 0,
      name: "Amit Goel",
      email: "amit.goel@alpaeroflex.com",
      seller_code: "DOM027",
      total_sales: "₹654802492",
    },
    {
      key: 1,
      name: "Alp Chennai",
      email: "alpchennai@alpoverseas.com",
      seller_code: "DOM063",
      total_sales: "₹542135154",
    },
    {
      key: 2,
      name: "Tushar Vij",
      email: "tusharvij@alpaeroflex.com",
      seller_code: "DOM034",
      total_sales: "₹154802492",
    },
    {
      key: 3,
      name: "Vishal Sood",
      email: "vishal.sood@alpaeroflex.com",
      seller_code: "DOM024",
      total_sales: "₹54552872",
    },
    {
      key: 4,
      name: "Moh Kareem",
      email: "kareem@alpaeroflex.com",
      seller_code: "DOM061",
      total_sales: "₹458201400",
    },
  ];
  const prodCols = [
    {
      key: 0,
      title: "Name",
      dataIndex: "name",
    },
    {
      key: 1,
      title: "SKU Code",
      dataIndex: "erp_item_code",
    },
    {
      key: 2,
      title: "Units Sold",
      dataIndex: "units_sold",
    },
    {
      key: 3,
      title: "Total Sales",
      dataIndex: "total_sales",
    },
  ];
  const prodData = [
    {
      key: 0,
      name: "AEROCELL RAIL NBR SHEET- 16X12X20 (LAM)",
      erp_item_code: "as53161220",
      units_sold: 789,
      total_sales: "₹85146660",
    },
    {
      key: 1,
      name: "EPDM TUBES 32x60 WITH G.C(GREY)",
      erp_item_code: "ET053206003",
      units_sold: 654,
      total_sales: "₹21232575",
    },
    {
      key: 2,
      name: "OPEN CELL ACCOSOUND SHEET 100MM",
      erp_item_code: "ac011001010",
      units_sold: 508,
      total_sales: "₹1584507",
    },
    {
      key: 3,
      name: "OPEN CELL ACCOSOUND SHEET 23MM",
      erp_item_code: "AC01231010",
      units_sold: 458,
      total_sales: "₹698468",
    },
    {
      key: 4,
      name: "NBR SHEET CL O 06X1.2X40",
      erp_item_code: "AS02061240",
      units_sold: 457,
      total_sales: "₹346981",
    },
  ];
  return (
    <div>
      <Title level={2} className="text-left pb-4">
        Report
      </Title>
      <div className="flex flex-row gap-4 max-w-full">
        <div className="bg-[#FAFAFB] rounded-lg w-[60%]">
          <LineChart className="w-full" />
        </div>
        <div className="bg-[#FAFAFB] rounded-lg w-[38%] p-4">
          <Title level={3} className="text-left">
            Top Performing Salesman
          </Title>
          <CommonAdminTable columns={columns} data={dataSource} />
        </div>
      </div>
      <div className="flex flex-row gap-4 max-w-full mt-4">
        <div className="bg-[#FAFAFB] rounded-lg w-[60%]">
          <LineChart className="w-full" />
        </div>
        <div className="bg-[#FAFAFB] rounded-lg w-[38%] p-4">
          <Title level={3} className="text-left">
            Top Performing Products
          </Title>
          <CommonAdminTable columns={prodCols} data={prodData} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
